const selectCount = (state) => state.counter.value;

const CounterSelector = {
  selectCount,
};

export default CounterSelector;
